import AddressWithTime from "components/shared/addressWithTime";
import { formatNumber } from "helpers/system";
import React from "react";

const SuitableDistributionBid = (props) => {
    const { item, index, params, openNewBidForm, organization } = props;
    const { id, firstBidPoint, lastBidPoint, emptyMileage, outputWithEmptyMileage, counterparty, price, createdBy } =
        item;
    return (
        <tr>
            <td>{params.start + index + 1}</td>
            <td className="b-table__point-cell">
                <AddressWithTime point={firstBidPoint} />
            </td>
            <td className="b-table__point-cell">
                <AddressWithTime point={lastBidPoint} />
            </td>
            <td>
                <small>{formatNumber(emptyMileage) || "-"}</small>
            </td>
            <td>
                <small>{formatNumber(outputWithEmptyMileage) || "-"}</small>
            </td>
            <td>
                <small>
                    {price
                        ? formatNumber(price, { style: "currency", currency: organization?.currency })
                        : "Стоимость не указана"}
                </small>
                <br />
                <small>{counterparty ? counterparty.name : "-"}</small>
            </td>
            <td>{createdBy ? createdBy.shortName : "-"}</td>
            <td className="align-middle text-center">
                <div className="btn btn-brand btn-xs" onClick={openNewBidForm.bind(this, id)}>
                    Назначить
                </div>
            </td>
        </tr>
    );
};

export default SuitableDistributionBid;
